var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { persist } from 'zustand/middleware';
import produce from 'immer';
import create from 'zustand';
export const useUpdateStore = () => {
    return useStore((store) => store.set);
};
export const useStore = create(persist((set) => ({
    // Use immer to update zustand state
    set: (fn) => set(produce(fn)),
    setStore: set,
    country: 'NLD',
    locale: undefined,
    formData: undefined,
    uid: undefined,
}), {
    name: 'fastned-zustand2',
    // add keys not needing to be persisted in app storage across sessions
    partialize: (_a) => {
        var state = __rest(_a, []);
        return state;
    },
}));
